<script>
export default {
    props:{
        type:String,
        status:String,
        cat:Number,
    },
    computed:{
        data(){
            if(this.type=="type-budget"){
                return {
                    '1': {style:"info",label:"In"},
                    '2': {style:"success",label:"Out"},
                    '3': {style:"danger",label:"In Out"},
                }[this.cat]
            }
            if(this.type=="work-status" || this.type=="project-work-status"){
                var map = {
                    'DRAFT': {style:"inverse", color:"#78909c", label:"Draft"},
                    'PLANNING': {style:"info", color:"#0288d1", label:"Planning"},
                    'IN_PROGRESS': {style:"primary", color:"#1976d2", label:"In Progress"},
                    'UAT': {style:"purple", color:"#8e44ad", label:"UAT"},
                    'TRAINING': {style:"danger", color:"#e91e63", label:"Training"},
                    'ON_HOLD': {style:"warning", color:"#f39c12", label:"On Hold"},
                    'COMPLETED': {style:"success", color:"#00c292", label:"Completed"},
                    'CANCELLED': {style:"red", color:"#d32f2f", label:"Cancelled"},
                    'MAINTENANCE': {style:"megna", color:"#009688", label:"Maintenance"},
                };
                var key = (this.status || '').toUpperCase();
                return map[key] || (this.status ? {style:"default", color:"#9e9e9e", label:this.status} : null);
            }
            var s = this.status ? this.status.toUpperCase() : '';
            return {
                "Y": {style:"success",label:"Active"},
                "N": {style:"warning",label:"Inactive"},
                "P": {style:"info",label:"Pending"},
                "C": {style:"success",label:"Closing"},
                "R": {style:"danger",label:"Rejected"},
            }[s] || {style:"default", label:this.status || '-'}
        }
    }
}
</script>

<template>
    <label v-if="data" :class="'label label-'+(data.style)" :style="data.color ? 'background-color:'+data.color+' !important; color:#fff;' : ''">{{data.label}}</label>
</template>